import React from "react";
import Header from "../../../components/Header";
import PassTips from "../../../components/HelpTip/passwordHint";
import { Redirect, Prompt, useNavigate } from "react-router-dom";
import NotFound from "../../NotFound";
import withAuth from "../../../services/withAuth";
import PageTitle from "../../../components/PageTitle";
import TextInput from "../../../components/Form/components/TextInput";
import SelectInput from "../../../components/Form/components/SelectInput";
import LoadingSpinner from "../../../components/LoadingSpinner";
import CheckboxInput from "../../../components/Form/components/CheckboxInput";
import AuthService from "../../../services/AuthService";
import MembersApi from "../../../services/portal-api/MembersApi";
import swal from "sweetalert";

class MultiUserEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                id: this.props.match.params.id,
                uname: '',
                password: '',
                passwordRe: '',
                secStage: '',
                timeoutPeriod: 0,
                tmpStage: '',
                admin: this.props.location.state.prevPath == '/area-managers' ? 4 : '',
                storeId: '',
                useGlobal: false,
                resetPassword: false,
                instances: [],
                amId: AuthService.getAdminType() == 4 ? AuthService.getUserId() : '',
                securityQuestion: false,
            },
            errors: {},
            isLoading: false,
            isEdited: false,
            viewSlug: null,
            stores: [],
            viewSlug: null,
            selectUnselect: false,
        }

        this.handleDynamicPlusClick = this.handleDynamicPlusClick.bind(this);
        this.handleDynamicMinusClick = this.handleDynamicMinusClick.bind(this);
    }

    componentDidMount = () => {
        document.title = "Edit User";
        document.body.className = "page--green";
        const id = this.props.match.params.id;
        this.getUserDetails(id);
        if (this.props.location.state.prevPath !== '/area-managers') {
            this.stores();
        } else {
            this.tabularStore(id);
        }
    }


    stores = () => {
        const isAdminType4 = AuthService.getAdminType() == 4;
        const handleFetchStores = (result) => {
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            }

            const stores = result.json.map((i) => ({
                key: i.id,
                value: i.name,
            }));

            this.setState({
                stores: stores,
            }, () => {
                console.log('page line 77: fetching all stores...');
            });
        };

        if (isAdminType4) {
            MembersApi.fetchStoresOfAM(handleFetchStores, AuthService.getUserId());
        } else {
            MembersApi.fetchAllStores(handleFetchStores);
        }
    };

    tabularStore = (id) => {
        const handleFetchStores = (result) => {
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            }

            const stores = result.json;

            this.setState({
                stores: stores,
                selectUnselect: stores[0].selectUnselect
            }, () => {
                console.log('line no. 100: fetching all stores in tabular format...');
            });
        };

        MembersApi.fetchAllStoresInTabularFormat(handleFetchStores, id);
    }

    getUserDetails = (param, superAdmin = null) => {
        const { data } = this.state;
        const handleUserFetch = (result) => {
            const newData = {
                ...data,
                uname: result.json.username,
                timeoutPeriod: result.json.timeout_period,
                useGlobal: result.json.is_global == 1 ? true : false,
                resetPassword: result.json.sec_stage === "qa" || result.json.sec_stage === "ps",
                tmpStage: result.json.sec_stage,
                secStage: result.json.sec_stage,
                securityQuestion: result.json.securityQuestion,
                id: result.json.id,
            };
            
            this.setState({ 
                data: newData
            }, () => {
                console.log("line no. 119: fetching user...");
            });

            const instanceArray = result.json.user_stores.map((v) => {
                let admin;
                switch (v.role_id) {
                    case 0:
                        admin = "user";
                        break;
                    case 1:
                        admin = "super_admin";
                        break;
                    case 2:
                        admin = "store_admin";
                        break;
                    case 3:
                        admin = "cs_admin";
                        break;
                    default:
                        admin = 0;
                }
                return { store: v.store_id, admin: admin };
            });

            const { instances } = this.state.data;
            const newInstances = [...instances, ...instanceArray];

            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    instances: superAdmin != null ? instanceArray : newInstances,
                },
            }), () => {
                console.log("newInstances ", newInstances);
            });
        }

        if (AuthService.getAdminType() == 4) {
            MembersApi.fetchOneUser(handleUserFetch, param, AuthService.getUserId());
        } else {
            MembersApi.fetchOneUser(handleUserFetch, param);
        }
    };

    admins = () => {
        return [
            {
                key: "store_admin",
                value: "Store Admin"
            },
            {
                key: "user",
                value: "Store User"
            }
        ];
    };

    adminsWithCustomerSupport = () => {
        return [
            {
                key: "super_admin",
                value: "Super Admin"
            },
            {
                key: "cs_admin",
                value: "Customer Support Admin"
            },
            {
                key: "user",
                value: "Store User"
            }
        ];
    }

    handleDynamicPlusClick = () => {
        const { instances } = this.state.data;

        const newInstances = [...instances, { store: '', admin: '' }];

        this.setState(prevState => ({
            data: {
                ...prevState.data,
                instances: newInstances,
            },
        }));
    };

    handleStoreChange = (event, index) => {
        const { value } = event.target;
        this.setState(prevState => {
            const updatedInstances = [...prevState.data.instances];
            updatedInstances[index].store = value;
            return {
                data: {
                    ...prevState.data,
                    instances: updatedInstances,
                },
            };
        });
    };

    handleAdminChange = (event, index) => {
        const { value } = event.target;
        this.setState(prevState => {
            const updatedInstances = [...prevState.data.instances];
            updatedInstances[index].admin = value;
            return {
                data: {
                    ...prevState.data,
                    instances: updatedInstances,
                },
            };
        });
    };

    handleDynamicMinusClick = (index, total = null) => {
        if (total != 1) {
            this.setState(prevState => ({
                data: {
                    ...prevState.data,
                    instances: prevState.data.instances.filter((_, i) => i !== index),
                },
            }), () => {
                console.log(`Dynamic dropdpown removed at index ${index}`);
            });
        } else {
            swal("Atleast one instance is required", {
                icon: "warning",
                buttons: false,
                timer: 3000
            });
        }
    };

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        const data = this.state.data;

        if (name == "timeoutPeriod") {
            data[name] = event.target.value == '' ? 0 : event.target.value;
            if (isNaN(data[name]) || data[name] < 0) {
                errors["timeoutPeriod"] = "The Inactivity Timeout needs to be a valid number greater than 0.";
            }
        } else if (name == "resetPassword") {
            data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
            data["secStage"] = data[name] ? (data["tmpStage"] != "sc" ? data["tmpStage"] : "qa") : "sc";
        } else if (name == "securityQuestion") {
            data[name] = event.target.checked == true ? 1 : 0;
        } else if (name == "useGlobal") {
            data[name] = event.target.checked;
            data["timeoutPeriod"] = data[name] ? 0 : data["timeoutPeriod"];
            delete errors["timeoutPeriod"];

        } else {
            data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
            if (name == "storeId" || name == "admin") {
                data["admin"] = data["storeId"] != data['tmpStoreId'] ? "user" : data["admin"];
            }
        }

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        }, () => {
            console.log("globus", this.state);
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();

        let passwordValidDefinition = [
            {
                minLength: 6,
                ErrorMessage: "Your password must be at least six characters long.",
            },
            {
                maxLength: 50,
                ErrorMessage: "Your password cannot be longer than 50 characters.",
            },
            {
                regex: /.*\d/,
                ErrorMessage: "Your password must contain at least one digit.",
            },
            {
                regex: /.*[a-zA-Z]/,
                ErrorMessage: "Your password must contain at least one letter.",
            },
            {
                regex: /.*[!@#$%^&*() =+_-]/,
                ErrorMessage: "Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.",
            },
        ];

        let password = this.state.data.password;
        let isvalid = true;
        const errors = this.state.errors;
        delete errors["regex"];
        delete errors["minLength"];
        delete errors["maxLength"];
        delete errors["reConfirm"];
        delete errors["admin"];
        delete errors["error"];

        if (password != this.state.data.passwordRe) {
            errors["reConfirm"] = "The confirmation password does not match or is empty."; 
            isvalid = false;
        }

        if (password && password.length > 0) {
            for (let i = 0; i < passwordValidDefinition.length; i++) {
                let validator = passwordValidDefinition[i];

                if (validator.hasOwnProperty("regex")) {
                    if (password.search(validator.regex) < 0) {
                        errors["regex"] = validator.ErrorMessage;
                        isvalid = false;
                    }
                }

                if (validator.hasOwnProperty("minLength")) {
                    if (password.length < validator.minLength) {
                        errors["minLength"] = validator.ErrorMessage;
                        isvalid = false;
                    }
                }

                if (validator.hasOwnProperty("maxLength")) {
                    if (password.length > validator.maxLength) {
                        errors["maxLength"] = validator.ErrorMessage;
                        isvalid = false;
                    }
                }
            }
        }

        this.setState({
            errors: errors,
            viewSlug: null
        });

        if (!isvalid) {
            window.scrollTo(0, 0);
            return false;
        }

        if (errors["timeoutPeriod"] != undefined) {
            return false;
        }

        const { instances } = this.state.data;
        
        let serializedInstances = [];
        // serializedInstances = instances.map(instance => ({
        //     store: instance.store,
        //     admin: this.props.location.state.prevPath == '/area-managers' ? 4 : instance.admin,
        // }));

        const serialState = (instance) => {
            serializedInstances.push({
                store: instance.store,
                admin: this.props.location.state.prevPath == '/area-managers' ? 4 : instance.admin,
            });
        }

        const swalAlert = (msg) => {
            swal(msg, {
                icon: "warning",
                buttons: false,
                timer: 3000
            });
        }

        // return statement doesnt work with forEach
        for (const instance of instances) {
            if (this.props.location.state.prevPath !== "/area-managers") {
                if ((instance.store != '' && instance.store != null) && (instance.admin != '' && instance.admin != null)) {
                    if (instance.admin == 'super_admin') { // remove other stores and roles if super_admin is present in the admin property of any of the array of objects
                        swalAlert("Super Admin as one of the role will force other associated stores to be removed");
                        serializedInstances = [];
                        serialState(instance);
                        break;
                    }
                    serialState(instance);
                    console.log("386", serializedInstances)
                } else {
                    swalAlert("Either a store or a role or both are not selected");
                    return false;
                }
            } else {
                if (instance.store != '' && instance.store != null) {
                    serialState(instance);
                } else {
                    swalAlert("Either a store or a role or both are not selected");
                    return false;
                }
            }
        }

        const sendParams = {
            ...this.state.data,
            instances: JSON.stringify(serializedInstances),
        };

        if (!AuthService.isAdmin()) {
            delete sendParams['timeoutPeriod'];
        }

        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });
        

        MembersApi.updateMultiUser(sendParams, (response) => {
            if (response.success) {
                this.setState({
                    isLoading: false,
                    isEdited: false,
                    viewSlug: response.json.message,
                }, () => {
                    const id = this.props.match.params.id;
                    if (serializedInstances.some(item => item.admin == 'super_admin')) {
                        this.getUserDetails(id, 'super_admin');
                    } else {
                        this.setState({
                            data: {
                                instances: []
                            }
                        }, () => {
                            console.log("instances", this.state.instances);
                            this.getUserDetails(id);
                        });
                    }

                });
            } else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: response.json.errors,
                    });
                } else if (response.json.error) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.error },
                    });
                } else {
                    this.setState({
                        isLoading: false,
                    });
                }
            }
        });
    };

    handleStoreCheckbox = (event, index) => {
        const { value, checked } = event.target;
        this.setState(prevState => {
            const updatedInstances = [...prevState.data.instances];
            
            const updatedStores = [...prevState.stores];
            const storeIndex = updatedInstances.findIndex(item => item.store == value);
            
            if (storeIndex !== -1) {
                updatedInstances.splice(storeIndex, 1);
            } else {
                updatedInstances.push({ store: value, admin: 4});
            }
            
            updatedStores[index].checked == true ? updatedStores[index].checked = false : updatedStores[index].checked = true;
            
            return {
                data: {
                    ...prevState.data,
                    instances: updatedInstances,
                },
                stores: updatedStores
            };
        }, () => {
            console.log("521 instances", this.state.data.instances);
        });
    }

    renderTable = () => {
        return (
            <div className="col" style={{ width: '100%', overflowX: 'auto' }}>
                <table>
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: 'white', border: 'none', display: 'inline-flex', width: '200px', verticalAlign: 'top' }} >
                                <label style={{ marginRight: '8px' }}>
                                    <input type="checkbox" checked={this.state.selectUnselect} onChange={this.handleSelectAll} />
                                </label>
                                {this.state.selectUnselect ? 'Unselect' : 'Select'} all stores
                            </td>
                        </tr>
                        <tr>
                            {this.state.stores.map((store, index) => {
                                return (
                                    <td style={{ backgroundColor: 'white', border: 'none', display: 'inline-flex', width: '200px', verticalAlign: 'top' }} key={index}>
                                        <label style={{ marginRight: '8px' }}>
                                            <input type="checkbox" value={store.id} checked={store.checked} onChange={(event) => this.handleStoreCheckbox(event, index)} />
                                        </label>
                                        {store.name}
                                    </td>
                                )

                            })}
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    handleSelectAll = (event) => {
        const { stores } = this.state;
        const isChecked = event.target.checked;
        let instances = [];

        const updatedStores = stores.map((store) => ({
            ...store,
            checked: isChecked
        }));

        if(isChecked) {
            instances = updatedStores.map((stores) => ({
                store: stores.id,
                admin: 4
            }));
        }
        
        this.setState(prevState => ({
            selectUnselect: isChecked,
            stores: updatedStores,
            data: {
                ...prevState.data,
                instances: instances,
            }
        }), () => {
            console.log("updatedStores ", instances);
        });
    }


    render() {
        console.log("this.state.selectUnselect", this.state.selectUnselect);
        let instances = [];
    
        if (this.props.location.state.prevPath !== "/area-managers") {
            instances = this.state.data.instances.map((instance, index) => (
                <React.Fragment key={index}>
                    <div className="col">
                        <SelectInput
                            name={`store[${index}]`}
                            label=""
                            value={instance.store}
                            error={this.state.errors.store}
                            onChange={event => this.handleStoreChange(event, index)}
                            options={this.state.stores}
                            required={true}

                        />
                    </div>
                    <div className="col">
                        <div className="col-2 gutter--40">
                            {this.props.location.state.prevPath !== "/area-managers" &&
                                <div className="col">
                                    <SelectInput
                                        name={`admin[${index}]`}
                                        label=""
                                        options={instance.store == "1" ? this.adminsWithCustomerSupport() : this.admins()}
                                        value={instance.admin}
                                        error={this.state.errors.admin}
                                        onChange={event => this.handleAdminChange(event, index)}
                                        required={true}
                                    />
                                </div>
                            }
                            <div className="col">
                                <div className="col-2 gutter--30 suburb-state-postcode">
                                    {index == 0 &&
                                        <div className="col">
                                            <span className="sub-title text--grey"></span>
                                            <br />
                                            <button
                                                type="button"
                                                name="dynamicBtn"
                                                className="btn btn--xsmall btn--color"
                                                onClick={() => this.handleDynamicMinusClick(index, instances.length)}
                                            >
                                                -
                                            </button>
                                        </div>
                                    }
                                    <div className="col">
                                        <span className="sub-title text--grey"></span>
                                        <br />
                                        <button
                                            type="button"
                                            name="dynamicBtn"
                                            className="btn btn--xsmall btn--color"
                                            onClick={index !== 0 ? () => this.handleDynamicMinusClick(index) : () => this.handleDynamicPlusClick(index)}
                                        >
                                            {index !== 0 ? "-" : "+"}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </React.Fragment>
            ));
        } else {
            if (this.state.stores.length > 0) {
                instances = this.renderTable();
            }
        }

        let viewUrl = this.props.location.state == undefined ? "Not Found" : this.props.location.state.prevPath;
        let pageTitle = this.props.location.state.prevPath == "/area-managers" ? "Edit Area Manager" : "Edit User";

        let loaderOffset = {
            top: 200,
            position: 'absolute',
            left: '50%',
        }

        let c = '';
        if (this.state.viewSlug) {
            c = <div className="alert alert--success alert--outline text--center margin--20">{this.state.viewSlug}</div>
        }

        const errorsmsg = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            errorsmsg.push(<li key={key} ><span>Sorry, unable to update user: <strong>{value}</strong></span></li>);
        }

        if (viewUrl == "Not Found") {

            if (AuthService.isAdmin()) {
                return (<NotFound>
                    {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                        <div className="sk-fading-circle" style={loaderOffset}>
                            <div className="sk-circle1 sk-circle" />
                            <div className="sk-circle2 sk-circle" />
                            <div className="sk-circle3 sk-circle" />
                            <div className="sk-circle4 sk-circle" />
                            <div className="sk-circle5 sk-circle" />
                            <div className="sk-circle6 sk-circle" />
                            <div className="sk-circle7 sk-circle" />
                            <div className="sk-circle8 sk-circle" />
                            <div className="sk-circle9 sk-circle" />
                            <div className="sk-circle10 sk-circle" />
                            <div className="sk-circle11 sk-circle" />
                            <div className="sk-circle12 sk-circle" />
                        </div>
                    </div>}
                </NotFound>);
            } else {
                return (<NotFound forbidden={true}><LoadingSpinner isVisible={this.state.isLoading} />
                    {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                        <div className="sk-fading-circle" style={loaderOffset}>
                            <div className="sk-circle1 sk-circle" />
                            <div className="sk-circle2 sk-circle" />
                            <div className="sk-circle3 sk-circle" />
                            <div className="sk-circle4 sk-circle" />
                            <div className="sk-circle5 sk-circle" />
                            <div className="sk-circle6 sk-circle" />
                            <div className="sk-circle7 sk-circle" />
                            <div className="sk-circle8 sk-circle" />
                            <div className="sk-circle9 sk-circle" />
                            <div className="sk-circle10 sk-circle" />
                            <div className="sk-circle11 sk-circle" />
                            <div className="sk-circle12 sk-circle" />
                        </div>
                    </div>}
                </NotFound>);
            }

        } else {

            return (<div>
                <Prompt when={this.state.isEdited} message="You have unsaved changes that will be lost. Are you sure you want to leave this page?" />
                <Header />
                <main className="content padding--80--bot" role="main">
                    <div className="container padding--60--top clearfix">

                        <header className="header--page clearfix">
                            <PageTitle back={viewUrl} title={pageTitle} />
                        </header>

                        {c}
                        {errorsmsg.length > 0 && <ul className="alert alert--outline alert--error margin--40--top">{errorsmsg}</ul>}

                        <form onSubmit={this.handleSubmit} className={AuthService.getAdminType() == 1 || AuthService.getAdminType() == 4 ? "validate loading--inline " : "margin--40--top validate loading--inline padding--90--bot"} autoComplete="off">
                            <span></span>
                            <div className="col-2 gutter--40 ">
                                <div className="col">
                                    <TextInput
                                        name="uname"
                                        label="Username"
                                        value={this.state.data.uname}
                                        error={this.state.errors.uname}
                                        required={true}
                                        onChange={this.handleInput}
                                    />
                                </div>
                                {(AuthService.getAdminType() == 1 || AuthService.getAdminType() == 4) && <div className="col"> <div className="col-2 gutter--40 ">
                                    <div className="col">
                                        <TextInput
                                            type="text"
                                            name="timeoutPeriod"
                                            label="Inactivity Timeout (Mins)"
                                            placeholder="Enter minutes .."
                                            value={this.state.data.timeoutPeriod == 0 ? '' : this.state.data.timeoutPeriod}
                                            error={this.state.errors.timeoutPeriod}
                                            onChange={this.handleInput}
                                            required={false}
                                            disabled={this.state.data.useGlobal ? true : false}
                                        />
                                    </div>
                                    <div className="col">
                                        <CheckboxInput
                                            name="useGlobal"
                                            title=""
                                            label={"Use global timeout settings"}
                                            isChecked={this.state.data.useGlobal}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                </div></div>}
                                <div className="col">
                                    <div className="col-2 gutter--40 ">
                                        <div className="col">
                                            <TextInput
                                                type="password"
                                                name="password"
                                                label="Password"
                                                value={this.state.data.password}
                                                error={this.state.errors.password}
                                                required={false}
                                                onChange={this.handleInput}
                                                tooltip={<PassTips>
                                                    <ul>
                                                        <li><span>Your password must be at least six characters long.</span></li>
                                                        <li><span>Your password must contain at least one digit and one letter</span></li>
                                                        <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                                    </ul>
                                                </PassTips>}
                                            />
                                        </div>
                                        <div className="col">
                                            <TextInput
                                                type="password"
                                                name="passwordRe"
                                                label="Re-confirm Password"
                                                value={this.state.data.passwordRe}
                                                error={this.state.errors.passwordRe}
                                                onChange={this.handleInput}
                                                required={false}
                                                tooltip={<PassTips>
                                                    <ul>
                                                        <li><span>Your password must be at least six characters long.</span></li>
                                                        <li><span>Your password must contain at least one digit and one letter</span></li>
                                                        <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                                    </ul>
                                                </PassTips>}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="col-2 gutter--40 "> 
                                        <div className="col">
                                            <CheckboxInput
                                                name="resetPassword"
                                                title=""
                                                label={"Change password at next login"}
                                                isChecked={this.state.data.resetPassword}
                                                onChange={this.handleInput}
                                            />
                                        </div>
                                        <div className="col">
                                            <CheckboxInput
                                                name="securityQuestion"
                                                title=""
                                                label={"Change security question at next login"}
                                                isChecked={this.state.data.securityQuestion}
                                                onChange={this.handleInput}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {instances}

                                <footer className="footer--form clearfix">
                                    <div className="footer--form__left">

                                    </div>
                                    <div className="footer--form__right">
                                        <button type="submit" className="btn btn--large btn--color">Update User</button>
                                    </div>
                                </footer>
                            </div>
                        </form>
                    </div>
                    {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                        <div className="sk-fading-circle" style={loaderOffset}>
                            <div className="sk-circle1 sk-circle" />
                            <div className="sk-circle2 sk-circle" />
                            <div className="sk-circle3 sk-circle" />
                            <div className="sk-circle4 sk-circle" />
                            <div className="sk-circle5 sk-circle" />
                            <div className="sk-circle6 sk-circle" />
                            <div className="sk-circle7 sk-circle" />
                            <div className="sk-circle8 sk-circle" />
                            <div className="sk-circle9 sk-circle" />
                            <div className="sk-circle10 sk-circle" />
                            <div className="sk-circle11 sk-circle" />
                            <div className="sk-circle12 sk-circle" />
                        </div>
                    </div>}
                </main>
            </div>);
        }

    }
}
export default withAuth(MultiUserEdit);
